<template>
    <div>
        <button class="btn btn-success" style="border-radius: 2px !important;" @click="openModal()">
            <i class="fas fa-cogs"></i> Adicionar novo e-mail
        </button>

        <b-row>
            <b-col>
                <b-table striped hover bordered sort-icon-left show-empty :items="tbData" :fields="fields"
                    :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered"
                    :current-page="currentPage" :per-page="perPage" thead-class="font-weight-bold">

                    <template #thead-top>
                        <tr style="background-color: #1c869a; color: #ffffff;">
                            <th colspan="5" class="text-center">Dados Gerais</th>
                            <th colspan="3" class="text-center">Dados SMTP</th>
                            <th colspan="3" class="text-center">Dados IMAP</th>
                            <th rowspan="2" class="text-center" style="vertical-align: middle; width: 100px;">Visualizar</th>
                        </tr>
                    </template>

                    <template v-if="loading" #empty>
                        <div class="text-center">
                            <b-spinner variant="dark" small></b-spinner> Processando, por favor, aguarde...
                        </div>
                    </template>

                    <template v-else #empty>
                        <h6 style="text-align: center">Nenhum resultado encontrado.</h6>
                    </template>

                    <template #cell(is_active)="data">
                        {{ data.item.is_active ? "✅" : "⛔" }}
                    </template>

                    <template #cell(created_at)="data">
                        {{ formatDate(data.item.created_at) }}
                    </template>

                    <template #cell(is_noreply)="data">
                        {{ data.item.is_noreply ? "✅ Sim" : "⛔ Não" }}
                    </template>

                    <template v-slot:cell(view-button)="{ item }">
                        <span>
                            <b-btn id="view-button" @click.prevent="openModal(item)" style="border-radius: 3px !important;">
                                <i class="far fa-eye" aria-hidden="true"></i>
                            </b-btn>
                        </span>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <b-row class="justify-content-between">
            <b-col md="4">
                <b-form-group label="Registros por página" label-for="per-page-select" label-cols-md="6" label-align-sm="right"
                label-size="sm" class="mb-0 align-self-center">
                <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" size="md"
                class="my-0"></b-pagination>
            </b-col>
        </b-row>

        <EmailConfigModal ref="EmailConfigModal" @updateConfigEmailsTable="updateTable"></EmailConfigModal>
    </div>
</template>

<script>
import axios from 'axios';
import EmailConfigModal from "./EmailConfigModal.vue";
import { formatDate } from "../../helpers/utils";

export default {
    name: "ConfigEmailsTable",
    components: { EmailConfigModal },
    data() {
        return {
            tbData: [],
            loading: false,
            fields: [
                {
                    key: 'is_active',
                    label: 'Ativo',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'created_at',
                    label: 'Data',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'email_address',
                    label: 'Endereço',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'account_name',
                    label: 'Nome da Conta',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'is_noreply',
                    label: 'No-reply',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'smtp_host',
                    label: 'Host',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'smtp_port',
                    label: 'Porta',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'smtp_username',
                    label: 'Usuário',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'imap_host',
                    label: 'Host',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'imap_port',
                    label: 'Porta',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'imap_username',
                    label: 'Usuário',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'view-button',
                    label: '',
                    sortable: false,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff', width: '100px', display: 'none' }
                },
            ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Ver mais" }],
            sortBy: '',
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            dataEdit: {},
        }
    },
    created() {
        this.getDataTable();
    },
    methods: {
        formatDate,
        openModal(value = null) {
            this.$refs.EmailConfigModal.openModal(value);
        },
        getDataTable() {
            axios.get("/emails/config")
                .then(({ data }) => {
                    this.tbData = data;
                    this.totalRows = data.length;
                })
                .catch((error) => console.error(error))
        },
        updateTable(data) {
            if (!data.id) return;
            const found = this.tbData.find(el => el.id === data.id);
            if (found) {
                Object.assign(found, data);
            } else {
                this.tbData.push(data);
            }
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
    }
}
</script>